import request from "services/Request"
import { serializeVoices, serializeVoice } from "types/Voice"

export function getTalents(params) {
	return request({
		url: `/shop/talents`,
		method: 'GET',
		params
	}, serializeVoices)
}

export function getTalentByUrl(url: string) {
	return request({
		url: url.startsWith('/api/v2/shop/products/') ?
            url.replace('/api/v2/shop/products', '/shop/talents') :
            url.replace('/api/v2', ''),
		method: 'GET'
	}, serializeVoice)
}

export function getTalentByCode(code: string) {
	return request({
		url: `/shop/talents/${code}`,
		method: 'GET'
	}, serializeVoice)
}
